module.exports = __webpack_public_path__ + "static/media/PDF-07.e7069f9d.webp";